import { render, staticRenderFns } from "./User.vue?vue&type=template&id=c95b4a6a&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95b4a6a",
  null
  
)

export default component.exports